import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default__default, { forwardRef } from 'react';
import PropTypes__default from 'prop-types';

const _excluded = ["id", "min", "max", "step", "disabled", "infoId", "displayValueId", "listId", "onChange"];
const RangeInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      id,
      min,
      max,
      step,
      disabled,
      infoId,
      displayValueId,
      listId,
      onChange
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default__default.createElement("input", _extends({
    type: "range",
    ref: ref,
    id: id,
    min: min,
    max: max,
    step: step,
    disabled: disabled
  }, infoId && {
    'aria-describedby': infoId
  }, displayValueId && {
    'aria-valuetext': displayValueId
  }, listId && {
    list: listId
  }, rest, {
    onChange: onChange
  }));
});
RangeInput.displayName = 'RangeInput';
RangeInput.defaultProps = {
  disabled: false,
  infoId: null,
  displayValueId: null,
  listId: null
};
RangeInput.propTypes = {
  id: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]).isRequired,
  min: PropTypes__default.number.isRequired,
  max: PropTypes__default.number.isRequired,
  step: PropTypes__default.number.isRequired,
  disabled: PropTypes__default.bool,
  infoId: PropTypes__default.string,
  displayValueId: PropTypes__default.string,
  listId: PropTypes__default.string,
  onChange: PropTypes__default.func.isRequired
};
var RangeInput$1 = RangeInput;

export { RangeInput$1 as default };
